import { store } from 'app/shared/store/store';
import { ProductCategory } from 'app/shared/models/product-category.model';
import { ContentMode } from 'app/shared/models/content.model';
import { featureService } from 'app/shared/services/feature/feature-service';
import { FeatureKey } from 'app/shared/models/feature-key';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';
import * as nbn from 'app/nbn/store/store';
import * as mobile from 'app/mobile/store/store';
import * as bundle from 'app/bundle/store/store';
import { bundleService } from 'app/shared/services/bundle/bundle.service';
import { isLocalDevelopment } from 'app/shared/utilities/helper-functions';

export const initStore = async (
  isBundleLandingPage?: boolean,
  isGuidedFlow?: boolean,
  productCategory?: ProductCategory,
  contentMode?: ContentMode,
  focusSku?: string,
  hostSpa?: string
): Promise<void> => {
  // Get and Load feature flags in store
  await featureService.loadFeaturesStatus([
    FeatureKey.BUNDLE_FLOW_ENABLED,
    FeatureKey.NBN_MOVERS_ENABLED,
    FeatureKey.NBN_MOVERS_CROSS_SELL_ENABLED,
    FeatureKey.NBN_COMMON_LINKS_ENABLED
  ]);

  /**
   * Once category is set we use appropriate product category services
   */
  store.set('hostSpa', hostSpa);
  if (productCategory) {
    store.set(StoreKeys.productCategory, productCategory);
  }

  store.set('contentMode', contentMode ?? 'publish');

  if (productCategory === 'nbn' && !isGuidedFlow) {
    await nbn.onStoreInit(isGuidedFlow);
  }
  if (productCategory === 'mobile plan' && !isGuidedFlow) {
    mobile.onStoreInit(isGuidedFlow);
  }

  if (isGuidedFlow) {
    bundle.onStoreInit(isGuidedFlow, isBundleLandingPage);
  }
  const isBundleFlow = bundleService.isExplicitBundleFlow();
  store.set('isExplicitBundleFlow', isBundleFlow);

  if (focusSku) {
    store.set('focusSku', focusSku);
  }
  if (isLocalDevelopment()) {
    (window as any).store = store;
  }
};
